import { isNullOrWhitespace } from 'vdlib';
import ReduxHelper from 'lib/ReduxHelper';
import { AUCTIONS_ACTION_TYPES as AT } from './Auctions.actions';
import { APP_ACTION_TYPES } from '../app/App.actions';
import { history } from '../Store';
import { getImageUrl, getThumbUrl } from 'lib/Utils';
import moment from 'moment';
import 'moment/locale/el';

const defaultAuctionsFilterState = [];
const initialGridPageNo = 0;

const defaultAuctionMapper = auction =>
  auction.EndDate || Array.isArray(auction.Images)
    ? {
        ...auction,
        EndDate: moment.utc(auction.EndDate),
        OnlineEndDate: moment.utc(auction.OnlineEndDate),
        CreatedDate: moment.utc(auction.CreatedDate),
        Images: (auction.Images || []).map(img => {
          return {
            Filepath: getImageUrl(img.Filename, auction.FolderNumber),
            Order: img.OrderNum,
          };
        }),
        Thumbnails: (auction.Images || []).map(img => {
          return {
            Filepath: getThumbUrl(img.Filename, auction.FolderNumber),
            Order: img.OrderNum,
          };
        }),
      }
    : auction;

export const defaultState = {
  message: null,
  filters: defaultAuctionsFilterState,
  pageNo: initialGridPageNo,

  fetchingCurrentAuctions: false,
  currentAuctions: null,

  fetchingNewAuctions: false,
  newAuctions: null,

  fetchingPendingApprovalAuctions: false,
  pendingApprovalAuctions: null,

  fetchingNoOfferAuctions: false,
  noOfferAuctions: null,

  fetchingForSelectionAuctions: false,
  forSelectionAuctions: null,

  fetchingParticipateToAuctions: false,
  participateToAuctions: null,

  fetchingOnlineAuctions: false,
  onlineAuctions: null,

  fetchingForAcceptanceAuctions: false,
  forAcceptanceAuctions: null,

  fetchingForDispatchAuctions: false,
  forDispatchAuctions: null,

  fetchingDispatchProblemAuctions: false,
  dispatchProblemAuctions: null,

  fetchingRejectedAuctions: false,
  rejectedAuctions: null,

  fetchingCompletedAuctions: false,
  completedAuctions: null,

  fetchingMerchantSummary: false,
  merchantSummaryData: null,

  fetchingLostAuctions: false,
  lostAuctions: null,

  fetchingImages: false,
  images: null,
  imagesError: null,

  uploadingImages: false,
  uploadImages: null,

  deleteImages: null,
  deleteImagesError: null,
  deleteImagesPending: false,

  reorderImagesPending: false,
  reorderImages: null,
  reorderImagesError: null,

  fetchingCurrentAuction: false,
  currentAuction: null,
  fetchingCurrentAuctionBids: false,
  currentAuctionBids: null,

  fetchingCurrentAuctionComments: false,
  currentAuctionComments: null,
  currentAuctionCommentsError: null,

  fetchingCurrentAuctionParts: false,
  currentAuctionParts: null,
  currentAuctionPartsError: null,

  creatingAuctionBids: false,
  creatingAuctionBidsFor: null,

  creatingAuction: false,
  creationError: null,
  auctionCreated: false,

  editingAuction: false,
  editError: null,
  auctionEdited: false,

  commentingAuction: false,
  commentError: null,
  auctionCommented: false,

  startingAuctions: false,
  endingAuction: false,
  endingAuctions: false,
  acceptingAuction: false,
  rejectingAuction: false,
  exportingAuction: false,
  cancellingAuction: false,
  dispatchingAuction: false,

  fetchingPartPriceHistory: false,
  partPriceHistory: null,

  removeImageLicensePlate: null,
  removeImageLicensePlateError: null,
  removeImageLicensePlatePending: false,
};

const auctionsReducer = (state = defaultState, action) => {
  switch (action.type) {
    case AT.AUCTIONS_FETCH_CURRENT:
      return Object.assign({}, state, { fetchingCurrentAuctions: true });
    case AT.AUCTIONS_FETCH_CURRENT_SUCCESS: {
      const currentAuctions = action.payload.Auctions.map(defaultAuctionMapper);

      // mapper to get Bids from online auction, instead server data
      const bidsFromOnlineMapper = a => {
        if (a.OnlineMode !== true) return a;
        const { Bids } = state.onlineAuctions.find(oa => oa.ID === a.ID) || {};
        return Bids ? { ...a, Bids } : a;
      };

      return Object.assign({}, state, {
        fetchingCurrentAuctions: false,
        currentAuctions:
          state.onlineAuctions && state.onlineAuctions.length > 0
            ? currentAuctions.map(bidsFromOnlineMapper)
            : currentAuctions,
        error: null,
      });
    }
    case AT.AUCTIONS_FETCH_CURRENT_FAIL:
      return Object.assign({}, state, {
        currentAuctions: null,
        error: ReduxHelper.extractError(action),
      });
    case AT.AUCTIONS_CLEAR_CURRENT:
      return Object.assign({}, state, {
        fetchingCurrentAuctions: false,
        currentAuctions: null,
        error: null,
      });

    case AT.AUCTIONS_FETCH_NEW:
      return Object.assign({}, state, { fetchingNewAuctions: true });
    case AT.AUCTIONS_FETCH_NEW_SUCCESS:
      return Object.assign({}, state, {
        fetchingNewAuctions: false,
        newAuctions: action.payload.Auctions.map(defaultAuctionMapper),
        error: null,
      });
    case AT.AUCTIONS_FETCH_NEW_FAIL:
      return Object.assign({}, state, {
        NewAuctions: null,
        error: ReduxHelper.extractError(action),
      });
    case AT.AUCTIONS_CLEAR_NEW:
      return Object.assign({}, state, {
        fetchingNewAuctions: false,
        newAuctions: null,
        error: null,
      });

    case AT.AUCTIONS_FETCH_PENDINGAPPROVAL:
      return Object.assign({}, state, {
        fetchingPendingApprovalAuctions: true,
      });
    case AT.AUCTIONS_FETCH_PENDINGAPPROVAL_SUCCESS:
      return Object.assign({}, state, {
        fetchingPendingApprovalAuctions: false,
        pendingApprovalAuctions:
          action.payload.Auctions.map(defaultAuctionMapper),
        error: null,
      });
    case AT.AUCTIONS_FETCH_PENDINGAPPROVAL_FAIL:
      return Object.assign({}, state, {
        pendingApprovalAuctions: null,
        error: ReduxHelper.extractError(action),
      });
    case AT.AUCTIONS_CLEAR_PENDINGAPPROVAL:
      return Object.assign({}, state, {
        fetchingPendingApprovalAuctions: false,
        pendingApprovalAuctions: null,
        error: null,
      });

    case AT.AUCTIONS_FETCH_FORSELECTION:
      return Object.assign({}, state, { fetchingForSelectionAuctions: true });
    case AT.AUCTIONS_FETCH_FORSELECTION_SUCCESS:
      return Object.assign({}, state, {
        fetchingForSelectionAuctions: false,
        forSelectionAuctions: action.payload.Auctions.map(defaultAuctionMapper),
        error: null,
      });
    case AT.AUCTIONS_FETCH_FORSELECTION_FAIL:
      return Object.assign({}, state, {
        forSelectionAuctions: null,
        error: ReduxHelper.extractError(action),
      });
    case AT.AUCTIONS_CLEAR_FORSELECTION:
      return Object.assign({}, state, {
        fetchingForSelectionAuctions: false,
        forSelectionAuctions: null,
        error: null,
      });

    case AT.AUCTIONS_FETCH_PARTICIPATETO:
      return Object.assign({}, state, { fetchingParticipateToAuctions: true });
    case AT.AUCTIONS_FETCH_PARTICIPATETO_SUCCESS:
      return Object.assign({}, state, {
        fetchingParticipateToAuctions: false,
        participateToAuctions:
          action.payload.Auctions.map(defaultAuctionMapper),
        error: null,
      });
    case AT.AUCTIONS_FETCH_PARTICIPATETO_FAIL:
      return Object.assign({}, state, {
        participateToAuctions: null,
        error: ReduxHelper.extractError(action),
      });
    case AT.AUCTIONS_CLEAR_PARTICIPATETO:
      return Object.assign({}, state, {
        fetchingParticipateToAuctions: false,
        participateToAuctions: null,
        error: null,
      });

    case AT.AUCTIONS_FETCH_ONLINE:
      return Object.assign({}, state, { fetchingOnlineAuctions: true });
    case AT.AUCTIONS_FETCH_ONLINE_SUCCESS:
      return Object.assign({}, state, {
        fetchingOnlineAuctions: false,
        onlineAuctions: action.payload.Auctions.map(defaultAuctionMapper),
        error: null,
      });
    case AT.AUCTIONS_FETCH_ONLINE_FAIL:
      return Object.assign({}, state, {
        onlineAuctions: null,
        error: ReduxHelper.extractError(action),
      });
    case AT.AUCTIONS_CLEAR_ONLINE:
      return Object.assign({}, state, {
        fetchingOnlineAuctions: false,
        onlineAuctions: null,
        error: null,
      });

    case AT.AUCTIONS_FETCH_FORACCEPTANCE:
      return Object.assign({}, state, { fetchingForAcceptanceAuctions: true });
    case AT.AUCTIONS_FETCH_FORACCEPTANCE_SUCCESS:
      return Object.assign({}, state, {
        fetchingForAcceptanceAuctions: false,
        forAcceptanceAuctions:
          action.payload.Auctions.map(defaultAuctionMapper),
        error: null,
      });
    case AT.AUCTIONS_FETCH_FORACCEPTANCE_FAIL:
      return Object.assign({}, state, {
        forAcceptanceAuctions: null,
        error: ReduxHelper.extractError(action),
      });
    case AT.AUCTIONS_CLEAR_FORACCEPTANCE:
      return Object.assign({}, state, {
        fetchingForAcceptanceAuctions: false,
        forAcceptanceAuctions: null,
        error: null,
      });

    case AT.AUCTIONS_FETCH_FORDISPATCH:
      return Object.assign({}, state, { fetchingForDispatchAuctions: true });
    case AT.AUCTIONS_FETCH_FORDISPATCH_SUCCESS:
      return Object.assign({}, state, {
        fetchingForDispatchAuctions: false,
        forDispatchAuctions: action.payload.Auctions.map(defaultAuctionMapper),
        error: null,
      });
    case AT.AUCTIONS_FETCH_FORDISPATCH_FAIL:
      return Object.assign({}, state, {
        forDispatchAuctions: null,
        error: ReduxHelper.extractError(action),
      });
    case AT.AUCTIONS_CLEAR_FORDISPATCH:
      return Object.assign({}, state, {
        fetchingForDispatchAuctions: false,
        forDispatchAuctions: null,
        error: null,
      });

    case AT.AUCTIONS_FETCH_DISPATCHPROBLEM:
      return Object.assign({}, state, {
        fetchingDispatchProblemAuctions: true,
      });
    case AT.AUCTIONS_FETCH_DISPATCHPROBLEM_SUCCESS:
      return Object.assign({}, state, {
        fetchingDispatchProblemAuctions: false,
        dispatchProblemAuctions:
          action.payload.Auctions.map(defaultAuctionMapper),
        error: null,
      });
    case AT.AUCTIONS_FETCH_DISPATCHPROBLEM_FAIL:
      return Object.assign({}, state, {
        dispatchProblemAuctions: null,
        error: ReduxHelper.extractError(action),
      });
    case AT.AUCTIONS_CLEAR_DISPATCHPROBLEM:
      return Object.assign({}, state, {
        fetchingDispatchProblemAuctions: false,
        dispatchProblemAuctions: null,
        error: null,
      });

    case AT.AUCTIONS_FETCH_REJECTED:
      return Object.assign({}, state, { fetchingRejectedAuctions: true });
    case AT.AUCTIONS_FETCH_REJECTED_SUCCESS:
      return Object.assign({}, state, {
        fetchingRejectedAuctions: false,
        rejectedAuctions: action.payload.Auctions.map(defaultAuctionMapper),
        error: null,
      });
    case AT.AUCTIONS_FETCH_REJECTED_FAIL:
      return Object.assign({}, state, {
        rejectedAuctions: null,
        error: ReduxHelper.extractError(action),
      });
    case AT.AUCTIONS_CLEAR_REJECTED:
      return Object.assign({}, state, {
        fetchingRejectedAuctions: false,
        rejectedAuctions: null,
        error: null,
      });

    case AT.AUCTIONS_FETCH_COMPLETED:
      return Object.assign({}, state, { fetchingCompletedAuctions: true });
    case AT.AUCTIONS_FETCH_COMPLETED_SUCCESS:
      return Object.assign({}, state, {
        fetchingCompletedAuctions: false,
        completedAuctions: action.payload.Auctions.map(defaultAuctionMapper),
        error: null,
      });
    case AT.AUCTIONS_FETCH_COMPLETED_FAIL:
      return Object.assign({}, state, {
        completedAuctions: null,
        error: ReduxHelper.extractError(action),
      });
    case AT.AUCTIONS_CLEAR_COMPLETED:
      return Object.assign({}, state, {
        fetchingCompletedAuctions: false,
        completedAuctions: null,
        error: null,
      });

    case AT.AUCTIONS_FETCH_LOST:
      return Object.assign({}, state, { fetchingLostAuctions: true });
    case AT.AUCTIONS_FETCH_LOST_SUCCESS:
      return Object.assign({}, state, {
        fetchingLostAuctions: false,
        lostAuctions: action.payload.Auctions.map(defaultAuctionMapper),
        error: null,
      });
    case AT.AUCTIONS_FETCH_LOST_FAIL:
      return Object.assign({}, state, {
        lostAuctions: null,
        error: ReduxHelper.extractError(action),
      });
    case AT.AUCTIONS_CLEAR_LOST:
      return Object.assign({}, state, {
        fetchingLostAuctions: false,
        lostAuctions: null,
        error: null,
      });

    case AT.AUCTIONS_FETCH_NOOFFER:
      return Object.assign({}, state, { fetchingNoOfferAuctions: true });
    case AT.AUCTIONS_FETCH_NOOFFER_SUCCESS:
      return Object.assign({}, state, {
        fetchingNoOfferAuctions: false,
        noOfferAuctions: action.payload.Auctions.map(defaultAuctionMapper),
        error: null,
      });
    case AT.AUCTIONS_FETCH_NOOFFER_FAIL:
      return Object.assign({}, state, {
        noOfferAuctions: null,
        error: ReduxHelper.extractError(action),
      });
    case AT.AUCTIONS_CLEAR_NOOFFER:
      return Object.assign({}, state, {
        fetchingNoOfferAuctions: false,
        noOfferAuctions: null,
        error: null,
      });

    case AT.AUCTION_UPLOAD:
      return Object.assign({}, state, {
        creatingAuction: true,
        creationError: null,
      });
    case AT.AUCTION_UPLOAD_SUCCESS:
      setTimeout(() =>
        history.push({ pathname: '/auctions/pending-approval' })
      );
      return Object.assign({}, state, {
        creatingAuction: false,
        auctionCreated: true,
        creationError: null,
      });
    case AT.AUCTION_UPLOAD_FAIL:
      return Object.assign({}, state, {
        auctionCreated: false,
        creatingAuction: false,
        creationError: action.error,
      });

    case AT.AUCTION_CREATE:
      return Object.assign({}, state, {
        creatingAuction: true,
        creationError: null,
      });
    case AT.AUCTION_CREATE_SUCCESS:
      setTimeout(() =>
        history.push({ pathname: '/auctions/pending-approval' })
      );
      return Object.assign({}, state, {
        auctionCreated: true,
        creatingAuction: false,
        creationError: null,
      });
    case AT.AUCTION_CREATE_FAIL:
      return Object.assign({}, state, {
        auctionCreated: false,
        creatingAuction: false,
        creationError: action.error,
      });
    case AT.AUCTION_CREATE_CLEAR:
      return Object.assign({}, state, {
        auctionCreated: false,
        creatingAuction: false,
        creationError: null,
      });

    case AT.AUCTION_EDIT:
      return Object.assign({}, state, {
        editingAuction: true,
        auctionEdited: null,
        editError: null,
      });
    case AT.AUCTION_EDIT_SUCCESS:
      return Object.assign({}, state, {
        editingAuction: false,
        auctionEdited: true,
        editError: null,
      });
    case AT.AUCTION_EDIT_FAIL:
      return Object.assign({}, state, {
        editingAuction: false,
        auctionEdited: null,
        editError: action.error,
      });
    case AT.AUCTION_EDIT_CLEAR:
      return Object.assign({}, state, {
        editingAuction: false,
        auctionEdited: null,
        editError: null,
      });

    case AT.AUCTION_FETCH_BIDS:
      return Object.assign({}, state, { fetchingCurrentAuctionBids: true });
    case AT.AUCTION_FETCH_BIDS_SUCCESS:
      return Object.assign({}, state, {
        fetchingCurrentAuctionBids: false,
        currentAuctionBids: action.payload.Bids,
      });
    case AT.AUCTION_FETCH_BIDS_FAIL:
      return Object.assign({}, state, {
        fetchingCurrentAuctionBids: false,
        currentAuctionBidsError: action.error,
      });
    case AT.AUCTION_CLEAR_BIDS:
      return Object.assign({}, state, {
        fetchingCurrentAuctionBids: false,
        currentAuctionBids: null,
        currentAuctionBidsError: null,
      });

    case AT.AUCTION_FETCH_COMMENTS:
      return Object.assign({}, state, { fetchingCurrentAuctionComments: true });
    case AT.AUCTION_FETCH_COMMENTS_SUCCESS:
      return Object.assign({}, state, {
        fetchingCurrentAuctionComments: false,
        currentAuctionComments: action.payload.Comments,
      });
    case AT.AUCTION_FETCH_COMMENTS_FAIL:
      return Object.assign({}, state, {
        fetchingCurrentAuctionComments: false,
        currentAuctionCommentsError: action.error,
      });
    case AT.AUCTION_CLEAR_COMMENTS:
      return Object.assign({}, state, {
        fetchingCurrentAuctionComments: false,
        currentAuctionComments: null,
        currentAuctionCommentsError: null,
      });

    case AT.AUCTION_FETCH_PARTS:
      return Object.assign({}, state, { fetchingCurrentAuctionParts: true });
    case AT.AUCTION_FETCH_PARTS_SUCCESS:
      return Object.assign({}, state, {
        fetchingCurrentAuctionParts: false,
        currentAuctionParts: action.payload.Parts,
      });
    case AT.AUCTION_FETCH_PARTS_FAIL:
      return Object.assign({}, state, {
        currentAuctionParts: false,
        currentAuctionPartsError: action.error,
      });
    case AT.AUCTION_CLEAR_PARTS:
      return Object.assign({}, state, {
        fetchingCurrentAuctionParts: false,
        currentAuctionParts: null,
        currentAuctionPartsError: null,
      });

    case AT.AUCTION_FETCH:
      return Object.assign({}, state, { fetchingCurrentAuction: true });
    case AT.AUCTION_FETCH_SUCCESS:
      return Object.assign({}, state, {
        fetchingCurrentAuction: false,
        currentAuction: defaultAuctionMapper(action.payload),
      });
    case AT.AUCTION_FETCH_FAIL:
      return Object.assign({}, state, {
        fetchingCurrentAuction: false,
        message: ReduxHelper.formatMessage(action),
      });
    case AT.AUCTION_CLEAR:
      return Object.assign({}, state, {
        fetchingCurrentAuction: false,
        currentAuction: null,
        fetchingCurrentAuctionBids: false,
        currentAuctionBids: null,
        fetchingCurrentAuctionComments: false,
        currentAuctionComments: null,
        error: null,
      });

    case AT.AUCTIONS_START:
      return Object.assign({}, state, { startingAuctions: true });
    case AT.AUCTIONS_START_SUCCESS:
      let newStartState = { startingAuctions: false },
        startedAuctions = action.payload.Auctions.map(defaultAuctionMapper);
      if (state.currentAuction != null)
        newStartState.currentAuction = startedAuctions[0];
      else if (state.pendingApprovalAuctions != null)
        newStartState.pendingApprovalAuctions = state.pendingApprovalAuctions
          .filter(
            a => startedAuctions.find(started => started.ID === a.ID) === null
          )
          .map(a => ({ ...a }));

      return Object.assign({}, state, newStartState);
    case AT.AUCTIONS_START_FAIL:
      return Object.assign({}, state, {
        startingAuctions: false,
        message: ReduxHelper.formatMessage(action),
      });

    case AT.AUCTION_END:
      return Object.assign({}, state, { endingAuction: true });
    case AT.AUCTION_END_SUCCESS:
      let newEndState = { endingAuction: false },
        endedAuction = defaultAuctionMapper(action.payload.Auction || {});
      if (state.currentAuction) newEndState.currentAuction = endedAuction;
      if (state.forSelectionAuctions)
        newEndState.forSelectionAuctions = state.forSelectionAuctions.filter(
          a => a.ID !== endedAuction.ID
        );
      return Object.assign({}, state, newEndState);
    case AT.AUCTION_END_FAIL:
      return Object.assign({}, state, {
        endingAuction: false,
        message: ReduxHelper.formatMessage(action),
      });

    case AT.AUCTIONS_SELECTED_END:
      return Object.assign({}, state, { endingAuctions: true });
    case AT.AUCTIONS_SELECTED_END_SUCCESS:
      let newEndAuctionsState = { endingAuctions: false },
        endedAuctions = action.payload.Auctions.map(defaultAuctionMapper);
      if (state.currentAuction != null)
        newEndAuctionsState.currentAuction = endedAuctions[0];
      if (state.forSelectionAuctions != null)
        newEndAuctionsState.forSelectionAuctions = state.forSelectionAuctions
          .filter(a => endedAuctions.find(ended => ended.ID === a.ID) === null)
          .map(a => ({ ...a }));
      return Object.assign({}, state, newEndAuctionsState);
    case AT.AUCTIONS_SELECTED_END_FAIL:
      return Object.assign({}, state, {
        endingAuctions: false,
        message: ReduxHelper.formatMessage(action),
      });

    case AT.AUCTION_COMMENT:
      return Object.assign({}, state, {
        commentingAuction: true,
        auctionCommented: null,
        commentError: null,
      });
    case AT.AUCTION_COMMENT_SUCCESS:
      return Object.assign({}, state, {
        commentingAuction: false,
        auctionCommented: true,
        commentError: null,
      });
    case AT.AUCTION_COMMENT_FAIL:
      return Object.assign({}, state, {
        commentingAuction: false,
        auctionCommented: null,
        commentError: action.error,
      });

    case AT.AUCTION_ACCEPT:
      return Object.assign({}, state, { acceptingAuction: true });
    case AT.AUCTION_ACCEPT_SUCCESS:
      let newState = { acceptingAuction: false },
        acceptedAuction = defaultAuctionMapper(action.payload.Auction || {});
      if (state.currentAuction != null)
        newState.currentAuction = acceptedAuction;
      if (state.forAcceptanceAuctions != null)
        newState.forAcceptanceAuctions = state.forAcceptanceAuctions
          .filter(a => a.ID !== acceptedAuction.ID)
          .map(a => ({ ...a }));

      return Object.assign({}, state, newState);
    case AT.AUCTION_ACCEPT_FAIL:
      return Object.assign({}, state, {
        acceptingAuction: false,
        message: ReduxHelper.formatMessage(action),
      });

    case AT.AUCTION_DISPATCH:
      return Object.assign({}, state, { dispatchingAuction: true });
    case AT.AUCTION_DISPATCH_SUCCESS:
      let newDispatchState = { dispatchingAuction: false },
        dispatchedAuction = defaultAuctionMapper(action.payload.Auction || {});
      if (state.currentAuction != null)
        newDispatchState.currentAuction = dispatchedAuction.id;
      else if (state.forDispatchAuctions != null)
        newDispatchState.forDispatchAuctions = state.forDispatchAuctions
          .filter(a => a.ID !== dispatchedAuction.ID)
          .map(a => ({ ...a }));

      return Object.assign({}, state, newDispatchState);
    case AT.AUCTION_DISPATCH_FAIL:
      return Object.assign({}, state, {
        dispatchingAuction: false,
        message: ReduxHelper.formatMessage(action),
      });

    case AT.AUCTION_REJECT:
      return Object.assign({}, state, { rejectingAuction: true });
    case AT.AUCTION_REJECT_SUCCESS:
      return Object.assign({}, state, {
        rejectingAuction: false,
        currentAuction: action.payload.Auction,
      });
    case AT.AUCTION_REJECT_FAIL:
      return Object.assign({}, state, {
        rejectingAuction: false,
        message: ReduxHelper.formatMessage(action),
      });

    case AT.AUCTIONS_CANCEL:
      return Object.assign({}, state, { cancellingAuctions: true });
    case AT.AUCTIONS_CANCEL_SUCCESS:
      let newCancelState = { cancellingAuctions: false },
        cancelledAuctions = action.payload.Auctions.map(defaultAuctionMapper);
      if (state.currentAuction != null)
        newCancelState.currentAuction = cancelledAuctions[0];
      else if (state.forSelectionAuctions != null)
        newCancelState.forSelectionAuctions = state.forSelectionAuctions
          .filter(a => cancelledAuctions.find(ca => ca.ID === a.ID) === null)
          .map(a => ({ ...a }));
      else if (state.pendingApprovalAuctions != null)
        newCancelState.pendingApprovalAuctions = state.pendingApprovalAuctions
          .filter(a => cancelledAuctions.find(ca => ca.ID === a.ID) === null)
          .map(a => ({ ...a }));

      return Object.assign({}, state, newCancelState);
    case AT.AUCTIONS_CANCEL_FAIL:
      return Object.assign({}, state, {
        cancellingAuctions: false,
        message: ReduxHelper.formatMessage(action),
      });

    case AT.AUCTIONS_CLEAR:
      return Object.assign({}, state, {
        currentAuctions: null,
        currentAuctionBids: null,
      });

    case AT.AUCTION_CREATE_BIDS:
      return {
        ...state,
        creatingAuctionBids: true,
        creatingAuctionBidsFor: action.payload.auctionId,
      };
    case AT.AUCTION_CREATE_BIDS_SUCCESS: {
      const {
          payload: { Bids, BestOffer, EndDate, OnlineEndDate },
        } = action,
        auctionId = Bids[0].AuctionID,
        keys = [
          'currentAuctions',
          'onlineAuctions',
          'newAuctions',
          'participateToAuctions',
        ],
        newState = {
          ...state,
          creatingAuctionBids: false,
          creatingAuctionBidsFor: null,
        };

      if (keys && keys.length > 0) {
        keys.map(
          k =>
            (newState[k] =
              state[k] &&
              state[k].map(a =>
                a.ID !== auctionId
                  ? a
                  : {
                      ...a,
                      EndDate: moment.utc(EndDate),
                      OnlineEndDate: moment.utc(OnlineEndDate),
                      BestOffer,
                      Bids,
                    }
              ))
        );
      }

      return newState;
    }
    case AT.AUCTION_CREATE_BIDS_FAIL:
      return Object.assign({}, state, {
        creatingAuctionBids: false,
        creatingAuctionBidsFor: null,
        message: ReduxHelper.formatMessage(action),
      });

    case AT.SET_AUCTIONS_GRID_FILTER:
      let newFilter = {
        Name: action.payload.name,
        Value: action.payload.value,
      };

      const existing = !!state.filters.find(f => f.Name === newFilter.Name);

      const newFilters =
        typeof newFilter.Value !== 'number' &&
        isNullOrWhitespace(newFilter.Value)
          ? state.filters.filter(f => f.Name !== newFilter.Name)
          : existing
          ? state.filters.map(f => (f.Name === newFilter.Name ? newFilter : f))
          : [...state.filters, newFilter];

      return {
        ...state,
        filters: newFilters,
      };

    case AT.CLEAR_AUCTIONS_GRID_FILTERS:
      return {
        ...state,
        filters: [],
      };

    case AT.SET_AUCTIONS_GRID_PAGE:
      return { ...state, pageNo: action.payload };
    case AT.CLEAR_AUCTIONS_GRID_PAGE:
      return { ...state, pageNo: initialGridPageNo };

    case AT.AUCTIONS_FETCH_MERCHANT_SUMMARY:
      return Object.assign({}, state, { fetchingMerchantSummary: true });
    case AT.AUCTIONS_FETCH_MERCHANT_SUMMARY_SUCCESS:
      return Object.assign({}, state, {
        fetchingMerchantSummary: false,
        merchantSummaryData: action.payload,
        error: null,
      });
    case AT.AUCTIONS_FETCH_MERCHANT_SUMMARY_FAIL:
      return Object.assign({}, state, {
        merchantSummaryData: null,
        error: ReduxHelper.extractError(action),
      });
    case AT.AUCTIONS_CLEAR_MERCHANT_SUMMARY:
      return Object.assign({}, state, {
        fetchingMerchantSummary: false,
        merchantSummaryData: null,
        error: null,
      });

    case AT.AUCTIONS_EXPORT_PDF:
      return Object.assign({}, state, { exportingAuction: true });
    case AT.AUCTIONS_EXPORT_PDF_SUCCESS:
      // // decode base64 string, remove space for IE compatibility
      let binary = atob(action.payload.Content.replace(/\s/g, '')),
        len = binary.length,
        buffer = new ArrayBuffer(len),
        view = new Uint8Array(buffer);
      for (var i = 0; i < len; i++) view[i] = binary.charCodeAt(i);

      // create the blob object with content-type "application/pdf"
      let blob = new Blob([view], { type: 'application/octet-stream' }),
        url = URL.createObjectURL(blob),
        a = document.createElement('a');
      document.body.appendChild(a);
      a.style = 'display: none';
      a.href = url;
      a.download = action.payload.FileName;
      a.click();
      window.URL.revokeObjectURL(url);

      return Object.assign({}, state, {
        exportingAuction: false,
      });
    case AT.AUCTIONS_EXPORT_PDF_FAIL:
      return Object.assign({}, state, {
        exportingAuction: false,
        message: ReduxHelper.formatMessage(action),
      });

    case AT.AUCTIONS_FETCH_HISTORY:
      return Object.assign({}, state, {
        fetchingPartPriceHistory: true,
        partPriceHistoryError: null,
      });
    case AT.AUCTIONS_FETCH_HISTORY_SUCCESS:
      return Object.assign({}, state, {
        fetchingPartPriceHistory: false,
        partPriceHistory: action.payload.PartPriceHistories,
      });
    case AT.AUCTIONS_FETCH_HISTORY_FAIL:
      return Object.assign({}, state, {
        fetchingPartPriceHistory: false,
        partPriceHistoryError: ReduxHelper.formatMessage(action),
      });
    case AT.AUCTIONS_CLEAR_HISTORY:
      return Object.assign({}, state, {
        fetchingPartPriceHistory: false,
        partPriceHistory: null,
        partPriceHistoryError: null,
      });

    case AT.AUCTION_FETCH_IMAGES:
      return { ...state, fetchingImages: true, images: null };
    case AT.AUCTION_FETCH_IMAGES_SUCCESS:
      return { ...state, fetchingImages: false, images: action.payload.Images };
    case AT.AUCTION_FETCH_IMAGES_FAIL:
      return {
        ...state,
        fetchingImages: false,
        images: null,
        imagesError: ReduxHelper.formatMessage(action),
      };
    case AT.AUCTION_CLEAR_IMAGES:
      return {
        ...state,
        fetchingImages: false,
        images: null,
        imagesError: null,
      };

    case AT.AUCTION_UPLOAD_IMAGES:
      return { ...state, uploadingImages: true, uploadImages: null };
    case AT.AUCTION_UPLOAD_IMAGES_SUCCESS:
      return { ...state, uploadingImages: false, uploadImages: action.payload };
    case AT.AUCTION_UPLOAD_IMAGES_FAIL:
      return {
        ...state,
        uploadingImages: false,
        uploadImages: null,
        uploadImagesError: ReduxHelper.formatMessage(action),
      };
    case AT.AUCTION_CLEAR_UPLOAD_IMAGES:
      return {
        ...state,
        uploadingImages: false,
        uploadImages: null,
        uploadImagesError: null,
      };

    case AT.AUCTION_DELETE_IMAGES:
      return { ...state, deleteImagesPending: true, deleteImages: null };
    case AT.AUCTION_DELETE_IMAGES_SUCCESS:
      return {
        ...state,
        deleteImagesPending: false,
        deleteImages: action.payload,
      };
    case AT.AUCTION_DELETE_IMAGES_FAIL:
      return {
        ...state,
        deleteImagesPending: false,
        deleteImages: null,
        deleteImagesError: ReduxHelper.formatMessage(action),
      };
    case AT.AUCTION_CLEAR_DELETE_IMAGES:
      return {
        ...state,
        deleteImagesPending: false,
        deleteImages: null,
        deleteImagesError: null,
      };

    case AT.AUCTION_REORDER_IMAGES:
      return { ...state, reorderImagesPending: true, reorderImages: null };
    case AT.AUCTION_REORDER_IMAGES_SUCCESS:
      return {
        ...state,
        reorderImagesPending: false,
        reorderImages: action.payload,
      };
    case AT.AUCTION_REORDER_IMAGES_FAIL:
      return {
        ...state,
        reorderImagesPending: false,
        reorderImages: null,
        reorderImagesError: ReduxHelper.formatMessage(action),
      };
    case AT.AUCTION_CLEAR_REORDER_IMAGES:
      return {
        ...state,
        reorderImagesPending: false,
        reorderImages: null,
        reorderImagesError: null,
      };

    case AT.AUCTIONS_REMOVE_IMAGE_LICENSE_PLATE:
      return {
        ...state,
        removeImageLicensePlatePending: true,
        removeImageLicensePlate: null,
      };
    case AT.AUCTIONS_REMOVE_IMAGE_LICENSE_PLATE_SUCCESS:
      return {
        ...state,
        removeImageLicensePlatePending: false,
        removeImageLicensePlate: action.payload,
      };
    case AT.AUCTIONS_REMOVE_IMAGE_LICENSE_PLATE_FAIL:
      return {
        ...state,
        removeImageLicensePlatePending: false,
        removeImageLicensePlate: null,
        removeImageLicensePlateError: ReduxHelper.formatMessage(action),
      };
    case AT.AUCTIONS_CLEAR_REMOVE_IMAGE_LICENSE_PLATE:
      return {
        ...state,
        removeImageLicensePlatePending: false,
        removeImageLicensePlate: null,
        removeImageLicensePlateError: null,
      };

    case AT.NEW_AUCTION_SET_GARAGE:
      return Object.assign({}, state, { newAuctionGarage: action.payload });
    case AT.NEW_AUCTION_CLEAR_GARAGE:
      return Object.assign({}, state, { newAuctionGarage: null });

    case AT.NOTIFY_ONLINE_AUCTION_START: {
      const endDatesState = {
        OnlineEndDate: moment.utc(action.payload.OnlineEndDate),
        EndDate: moment.utc(action.payload.EndDate),
      };
      const newState = {
        ...state,
        onlineAuctions: [
          ...state.onlineAuctions,
          {
            ...action.payload,
            ...endDatesState,
            OnlineMode: true,
            IsOnlineAuction: true,
          },
        ],
      };

      // set onlineMode to true if auction already in currentAuctions
      const { ID: currentAuctionsID } =
        (state.currentAuctions || []).find(a => a.ID === action.payload.ID) ||
        {};
      if (currentAuctionsID)
        newState.currentAuctions = state.currentAuctions.map(a =>
          a.ID !== currentAuctionsID
            ? a
            : {
                ...a,
                ...endDatesState,
                Bids: action.payload.Bids,
                OnlineMode: true,
              }
        );

      // ditto for current auction
      if (state.currentAuction && state.currentAuction.ID === action.payload.ID)
        newState.currentAuction = {
          ...state.currentAuction,
          ...endDatesState,
          Bids: action.payload.Bids,
          OnlineMode: true,
        };

      return newState;
    }
    case AT.NOTIFY_ONLINE_AUCTION_END: {
      const newState = {
        ...state,
        onlineAuctions: state.onlineAuctions.filter(
          a => a.ID !== action.payload.ID
        ),
      };

      // trigger auction refetch, if it is current auction
      if (state.currentAuction && state.currentAuction.ID === action.payload.ID)
        newState.currentAuction = {
          ...state.currentAuction,
          OnlineMode: false,
        };

      // ditto for current auctions
      const { ID: currentAuctionsID } =
        (state.currentAuctions || []).find(a => a.ID === action.payload.ID) ||
        {};
      if (currentAuctionsID)
        newState.currentAuctions = state.currentAuctions.filter(
          a => a.ID !== currentAuctionsID
        );

      return newState;
    }
    case AT.NOTIFY_ONLINE_AUCTION_BID: {
      const { Amount, AuctionID, BidderID, EndDate } = action.payload;
      const newState = {
        ...state,
        onlineAuctions: state.onlineAuctions.map(a =>
          a.ID === AuctionID
            ? {
                ...a,
                OnlineEndDate: moment.utc(EndDate),
                Bids: [
                  ...a.Bids.filter(b => b.BidderID !== BidderID),
                  {
                    Amount,
                    BidderID,
                    ID: 0,
                    Won: false,
                  },
                ],
              }
            : a
        ),
      };

      // Update bids if auction is currently selected
      if (state.currentAuction && state.currentAuction.ID === AuctionID) {
        const bidExists = state.currentAuction.Bids.find(
          b => b.BidderID === BidderID
        );
        newState.currentAuction = {
          ...state.currentAuction,
          Bids: bidExists
            ? state.currentAuction.Bids.map(b =>
                b.BidderID === BidderID ? { ...b, Amount } : b
              )
            : [...state.currentAuction.Bids, { Amount, BidderID }],
        };
      }

      // Ditto for current bids
      const currentAuction = (state.currentAuctions || []).find(
        a => a.ID === AuctionID
      );
      if (currentAuction) {
        const bidExists = currentAuction.Bids.find(
          b => b.BidderID === BidderID
        );
        const newBid = {
          Amount,
          BidderID,
        };
        newState.currentAuctions = state.currentAuctions.map(a =>
          a.ID === AuctionID
            ? {
                ...a,
                Bids: bidExists
                  ? a.Bids.map(b =>
                      b.BidderID === BidderID
                        ? {
                            ...b,
                            ...newBid,
                          }
                        : b
                    )
                  : [...a.Bids, newBid],
              }
            : a
        );
      }

      return newState;
    }
    case APP_ACTION_TYPES.LOGOUT:
      return defaultState;
    default:
      return state;
  }
};

export default auctionsReducer;
